import {
  SidebarMenuGroupConfig,
  SidebarMenuGroupView,
  SidebarMenuItemConfig,
  SidebarMenuItemView,
  SidebarRouteMatchMode,
} from './sidebar.models';

function normalizeUrl(url: string): string {
  const withoutQuery = url.split('?')[0];
  if (withoutQuery === '/') {
    return '/';
  }
  return withoutQuery.replace(/\/+$/, '');
}

export function isSidebarRouteActive(
  currentUrl: string,
  targetRoute: string,
  mode: SidebarRouteMatchMode
): boolean {
  const normalizedCurrent = normalizeUrl(currentUrl);
  const normalizedTarget = normalizeUrl(targetRoute);

  if (mode === 'exact') {
    return normalizedCurrent === normalizedTarget;
  }

  return (
    normalizedCurrent === normalizedTarget ||
    normalizedCurrent.startsWith(`${normalizedTarget}/`)
  );
}

function mapItem(item: SidebarMenuItemConfig, currentUrl: string): SidebarMenuItemView {
  const mappedSubItems = item.subItems?.map((subItem) => mapItem(subItem, currentUrl));
  const hasActiveSubItem = mappedSubItems?.some((subItem) => subItem.isActive) ?? false;
  const hasActiveRoute =
    item.route !== undefined
      ? isSidebarRouteActive(currentUrl, item.route, item.matchMode ?? 'prefix')
      : false;

  return {
    ...item,
    isActive: hasActiveRoute || hasActiveSubItem,
    subItems: mappedSubItems,
  };
}

export function bindSidebarMenuRuntime(
  menuConfig: SidebarMenuGroupConfig[],
  currentUrl: string
): SidebarMenuGroupView[] {
  return menuConfig.map((group) => ({
    id: group.id,
    label: group.label,
    items: group.items.map((item) => mapItem(item, currentUrl)),
  }));
}
